import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { UserPlus, ArrowRight } from "lucide-react";
import { listResource } from "@/lib/api";
import { fmtDate } from "@/components/common";

// Highlights leads that haven't been claimed by a salesperson yet.
export default function UnclaimedLeads() {
  const { data } = useQuery({ queryKey: ["leads"], queryFn: () => listResource("leads"), refetchInterval: 5000 });
  const leads = (data || []).filter((l) => (l.salesperson || "") === "Unassigned");
  if (!leads.length) return null;

  return (
    <div data-testid="unclaimed-leads" className="border-2 border-[#E0A81E] bg-white">
      <div className="flex items-center gap-2 px-5 py-3 bg-[#E0A81E] text-[#16265F]">
        <UserPlus className="w-5 h-5" />
        <span className="font-head font-bold uppercase tracking-wide">Unclaimed Leads</span>
        <span className="ml-2 text-[#16265F]/70 text-sm">{leads.length} waiting</span>
      </div>
      <div className="divide-y divide-gray-100">
        {leads.map((l, i) => (
          <Link key={i} to="/leads" data-testid="unclaimed-lead-item"
            className="flex items-center justify-between gap-3 px-5 py-3 hover:bg-[#E0A81E]/10 transition-colors">
            <div className="min-w-0">
              <div className="font-medium truncate">{l.customer || "—"}</div>
              <div className="text-sm text-gray-500 truncate">
                {[l.equipment, l.date_in ? `in ${fmtDate(l.date_in)}` : ""].filter(Boolean).join(" · ")}
              </div>
            </div>
            <span className="shrink-0 inline-flex items-center gap-1 text-xs font-bold uppercase tracking-wide text-[#16265F]">
              Claim <ArrowRight className="w-4 h-4" />
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}
